<template>
  <div id="realTimeData">
    <el-row class="full_height">
      <el-col :span="4" class="positon_relative">
        <el-menu
          class="nav_menu"
          text-color="#A7CCF6"
          active-text-color="#fff"
        >
          <el-submenu :index="item.code" v-for=" item  in menus" :key="item.code">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item-group v-for="child in item.childList" :key="child.code">
              <el-menu-item :index="child.code" @click="getMeasures(child.code)">{{ child.name }}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>

      </el-col>
      <el-col :span="20" class="full_height">
        <div id="contentHight" class="full_height tab_content">
            <div style="text-align: center">
              <div style="position: relative;display: inline-block;">
                <el-image :src="url+path" v-if="path" style="height: 40vh" mode="widthFix" ></el-image>
                <el-popover v-for="(item,index) in infoPics " :key="index"
                            ref="popoverTotile"
                            popper-class="popoverDiv"
                            placement="top-start"
                            width="100"
                            trigger="hover"
                            v-model="popoverStatus[index]"
                >
                  <div class="colorContent" :id="'popover'+measures[index].measureNo">
                    <div>{{measures[index].alias}}</div>
                    <div>{{ measures[index].measureNo }}</div>
                    <div>
                      <el-button slot="reference" circle size="mini" :type="item"></el-button>
                    </div>
                  </div>
                  <el-button :id="`buttonColor${measures[index].measureNo}`" slot="reference" circle size="mini" :type="item"
                             :style="{'position': 'absolute','left':measures[index].measureX+'px','top':measures[index].measureY+'px','width':'20px'}">
                  </el-button>
                </el-popover>
              </div>
            </div>

          <el-row class="miniContent" >
            <div @click="arrowClick('left')" v-if="Math.ceil(measures.length/10)>1">
              <img src="../../assets/images/left_n.png" alt="">
            </div>
            <el-carousel class="miniCar" ref="cardShow" :interval="5000" :autoplay="false" arrow="never" indicator-position="none">
              <el-carousel-item v-for="item in (Math.ceil(measures.length/10))" :key="item">
                <template v-for="num in 10">
                  <div @mouseover="changeColor(measures[((item - 1) * 10 + num - 1)].measureNo,((item-1)*10+num-1))"
                       @mouseout="backColor(measures[((item - 1) * 10 + num - 1)].measureNo,((item-1)*10+num-1))"
                       class="mini_chart_panel" :key="num" v-if="measures.length>((item-1)*10+num-1)">
                    <img src="../../assets/images/databg.png">
                    <div class="chart_content">
                      <el-row class="full_width " style="padding: 5% 8%;padding-bottom: 0px;font-size: 12px;    display: flex;flex-direction: row; align-items: center">
                        <el-col :span="10">{{ measures[((item - 1) * 10 + num - 1)].alias }}</el-col>
                        <el-col :span="10">{{ measures[((item - 1) * 10 + num - 1)].measureNo }}</el-col>
                        <!--                        <el-col :span="4"><img src="../../assets/img/1.png" width="20"></el-col>-->
                        <el-col :span="2"><div :id="`statusC${measures[((item - 1) * 10 + num - 1)].measureNo}`"  class="circularStatus"></div></el-col>
                        <el-col :span="2">
                          <el-checkbox class="poverClassFlag"
                                       @change.native="showPopover(((item-1)*10+num-1),$event)"></el-checkbox>
                        </el-col>
                      </el-row>
                      <el-row
                        @click.native="getChart(measures[((item - 1) * 10 + num - 1)].measureNo, measures[((item - 1) * 10 + num - 1)].alias,measures[((item - 1) * 10 + num - 1)].alarmDataJson)">
                        <el-col
                          class="mini_chart" :id="'data'+measures[((item - 1) * 10 + num - 1)].measureNo">
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </template>
              </el-carousel-item>
            </el-carousel>
            <div @click="arrowClick('right')" v-if="Math.ceil(measures.length/10)>1">
              <img src="../../assets/images/right_n.png" alt="">
            </div>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title=lableName
      center
      :visible.sync="chartDialogVisible"
      :modal-append-to-body='false'
      @opened="loadChartData"
      class="loadDialog"
      width="50%">
      <div style="height: 500px;width: 99%" id="mainChart"></div>
      <div id="changeLine"></div>
    </el-dialog>
<!--    <home-footer></home-footer>-->
  </div>
</template>

<script>
    import echarts from 'echarts'
    import $ from 'jquery'
    import ChartModal from './ChartModal'
    import WindDirectionModal from './WindDirectionModal'
    // import HomeFooter from '../../components/Footer'
    import measures from "../project/measures";
    // 声明Viewer及其它

    export default {
        name: 'RealTimeMonitor',
        components: {
            ChartModal,
            WindDirectionModal,
            // HomeFooter,
        },
        data() {
            return {
                numColor:'',
                menus: null,//左侧菜单数组
                url: null,//静态文件前缀
                path: null,//模型bimtoken或者图片的路径
                measures: [],//测点信息数组
                hoverList: [],
                chooseID:'',//选中点
                measureNos: [],//测点编号集合
                allPoint:[],//测点ID集合
                infoPics: [],//预报警按钮颜色
                popoverStatus: [],//popover显示状态
                systemType: '0',//系统类型
                viewer3D: null,
                objectMap: {},//objectid与measure的映射关系
                loadComplete: false,//bim模型加载完成
                drawableContainer: null,//测点画布控件
                // webSocketUrl: "ws://192.168.8.120:60000/monitor/imserver/", //本地
               webSocketUrl: localStorage.getItem("websocketUrl"), //线上
                socket: "",
                currentpoint:'', //是否自定义展示
                meassureData: {},//监测数据保存的对象
                markLineData:[],//选中的测点
                charts: {},//保存图表实例
                chartDialogVisible: false,//弹窗
                mainMeasureNo: null,//弹窗目前的测点
                lableName:'',//
                norValue:'',
                bimfacePopoverId: {},//存放bimface弹框id
                isFullScreen: false,//是否设置全屏
                showMini:true, //是否展示首页下方小图标
            }
        },
        watch:{},
        computed: {},
        mounted: function () {
            this.currentpoint = localStorage.getItem('currentpoint');
            this.url = localStorage.getItem("url")
            this.path = localStorage.getItem("path")
            this.systemType = localStorage.getItem("systemType");
            this.$axios.get('/api/monitor/project/measure/parameterSelection').then(res => {
                if (res.data.status == 200) {
                    this.menus = res.data.datas.values;
                }
            });
            // 刚进页面展示所有折线图
            this.getMeasures('all');
            //socket监听
            this.socketInit();
        },
        methods: {
            /*鼠标移入移出测点颜色*/
            changeColor(num,index){
                $('#buttonColor'+num).css("background","red")
            },
            backColor(num,index){
                $('#buttonColor'+num).css("background","#85ce61")
            },
            /*左右箭头方法*/
            arrowClick(val) {
                if(val === 'right') {
                    this.$refs.cardShow.next()
                } else {
                    this.$refs.cardShow.prev()
                }
            },
            getMeasures(code) {
                this.measures = [];
                this.infoPics= []
                this.$axios.get('/api/monitor/realTimeMonitor/getMeasuresByCode?code=' + code).then(res => {
                    if (res.data.status == 200) {
                        this.measures = res.data.datas.values;
                        this.initMeasure();
                        //初始化数据，用数组装是为了方便修改路径
                        for (let i = 0; i < this.measures.length; i++) {
                            this.infoPics.splice(i, 1, 'success');
                            // this.popoverStatus.push(i, 1, false);
                            this.objectMap[this.measures[i].modelObjectId] = this.measures[i];
                            this.measureNos.splice(i, 1, this.measures[i].measureNo);
                        }
                        //获取最近的100条数据
                        this.getRecentDatas();
                        this.measures.forEach(item=>{
                            this.allPoint.push(item.modelObjectId)
                        })
                        //高速socketserver应该获取的数据
                    } else {
                        this.$message({
                            type: "error",
                            message: res.data.message,
                            showClose: true
                        });
                    }
                })
            },
            getRecentDatas() {
                this.$axios.post('/api/monitor/realTimeMonitor/getDatas', this.measureNos).then(res => {
                    let resDatas = res.data.datas.values;
                    resDatas.forEach(resData => {
                        let dataArray = [];
                        if(resData.dataList.length>0){
                            for (let i = 0; i < resData.dataList.length; i++) {
                                let dataValues = JSON.parse(resData.dataList[i].dataJson);
                                for (let j = 0; j < dataValues.length; j++) {
                                    if (dataArray[j] == null) {
                                        dataArray[j] = [];
                                    }
                                    dataArray[j].push([resData.dataList[i].dataTime, dataValues[j]]);
                                }
                            }
                            this.meassureData[resData.measureNo] = dataArray;
                        }
                    });
                    for (let key in this.meassureData) {
                        this.drawChart(key);
                    }
                    this.send(this.measureNos);
                })
            },
            changePopover(e,value){
                console.log(e,value,this.$refs.popoverTotile)
            },
            /*选择勾选框*/
            showPopover(index, ele) {
                let statu = ele.target.checked;
                this.popoverStatus.splice(index, 1, statu);
                //判断背景颜色
                var newArr = this.meassureData[this.measures[index].measureNo]
                var numberMeasure = this.measures[index].measureNo
                if (newArr) {
                var lastArr = [];
                var showArr = [];
                newArr.forEach(item => {
                    lastArr.push(item.slice(-1))
                });
                lastArr.forEach(item=>{
                    showArr.push(item[0][1])
                })
                this.measures[index].newobj=showArr.join(',')
                showArr = [];
                lastArr = [];
                var colorArr = [];
                    newArr.forEach(item => {
                        lastArr.push(item.slice(-1))
                    });
                    lastArr.forEach((item, index) => {
                        this.measures.forEach(i => {
                            if (numberMeasure == i.measureNo) {
                                if (Number(item[0][1]) > Number(JSON.parse(i.alarmDataJson).earlyWarningValue.split(',')[index])) {
                                    if (Number(item[0][1]) > Number(JSON.parse(i.alarmDataJson).alarmValue.split(',')[index])) {
                                        colorArr.push('red')
                                    } else {
                                        colorArr.push('yellow')
                                    }
                                } else {
                                    colorArr.push('green')
                                }
                            }
                        })
                    })
                    this.drawBack(numberMeasure,colorArr)
                }
            },
            /*绘制自定义label*/
            drawBack(numberMeasure,colorArr){
                this.measures.forEach(i => {
                    if (numberMeasure === i.measureNo) {
                        if(colorArr.indexOf('red')!==-1){
                            setTimeout(()=>{  $('#popover' + i.measureNo).css("background", "red")},250)
                        }else if(colorArr.indexOf('yellow')!==-1){
                            setTimeout(()=>{ $('#popover' + i.measureNo).css("background", "#DDAA00")},250)
                        } else{
                            setTimeout(() => { $('#popover' + i.measureNo).css("background", "green")}, 250)
                        }
                    }
                })
            },
            //websocket相关方法（地址异常或连接出错时仅提示，不影响页面其他加载）
            socketInit: function () {
                try {
                    if (typeof (WebSocket) === "undefined") {
                        this.$message({
                            type: "error",
                            message: "浏览器不支持socket",
                            showClose: true
                        });
                        return;
                    }
                    const isHttps = typeof window !== "undefined" && window.location && window.location.protocol === "https:";
                    const defaultBase = `${isHttps ? "wss" : "ws"}://detect.scentralit.com:9000/monitor/imserver`;

                    const raw = (this.webSocketUrl != null && this.webSocketUrl !== "undefined" && String(this.webSocketUrl).trim() !== "")
                        ? String(this.webSocketUrl).trim()
                        : defaultBase;

                    const baseUrl = raw
                        .replace(/\/+$/, "")
                        .replace(/^https:\/\//i, "wss://")
                        .replace(/^http:\/\//i, "ws://")
                        .replace(/^\/\//, `${isHttps ? "wss:" : "ws:"}//`);

                    const normalizedBaseUrl = /^wss?:\/\//i.test(baseUrl)
                        ? baseUrl
                        : `${isHttps ? "wss" : "ws"}://${baseUrl.replace(/^\/+/, "")}`;

                    if (!/^wss?:\/\//i.test(normalizedBaseUrl)) {
                        this.$message({ type: "warning", message: "WebSocket 地址格式有误，已跳过连接", showClose: true });
                        return;
                    }

                    const token = localStorage.getItem("token") || "";
                    const wsUrl = `${normalizedBaseUrl}/${token}?token=${encodeURIComponent(token)}`;

                    this.socket = new WebSocket(wsUrl);
                    this.socket.onopen = this.socketOpen;
                    this.socket.onerror = this.socketError;
                    this.socket.onmessage = this.getMessage;
                } catch (err) {
                    console.warn("[socketInit] WebSocket 初始化异常，不影响其他功能:", err);
                    try {
                        this.$message({ type: "warning", message: "实时推送连接异常，其他功能正常使用", showClose: true });
                    } catch (e) { /* 忽略提示失败 */ }
                }
            },
            socketOpen: function () {
                this.$message({
                    type: "success",
                    message: "socket连接成功",
                    showClose: true
                });
            },
            socketError: function () {
                try {
                    this.$message({
                        type: "error",
                        message: "socket连接失败",
                        showClose: true
                    });
                } catch (e) {
                    console.warn("[socketError]", e);
                }
            },
            getMessage: function (msg) {
                let data = JSON.parse(msg.data);
                let dataArray = this.meassureData[data.measureNo];
                if (dataArray == null) {
                    dataArray = [];
                }
                let dataJson = data.dataJson;
                if (dataJson == null) {
                    return;
                }
                let newData = JSON.parse(dataJson);
                let d = new Date(data.dataTime);
                for (let i = 0; i < newData.length; i++) {
                    if (dataArray[i] == null) {
                        dataArray[i] = [];
                    }
                    dataArray[i].push([this.formatDate(d), newData[i]]);
                    if (dataArray[i].length > 100) {
                        dataArray[i].shift();
                    }
                }
                //绘制miniEchart
                this.drawChart(data.measureNo);
                //判断监测点状态（正常、预警、报警）
                this.showStatus(data.measureNo)
                if (data.measureNo === this.mainMeasureNo) {
                    this.loadChartData();
                }
            },
            send: function (code) {
                let json = {'measureNo': code};
                this.socket.send(JSON.stringify(json))
            },
            close: function () {
                console.log("socket已经关闭")
            },

            /*获取监测点状态*/
            showStatus(key){
                let statusArr =[]
                for (let i = 0; i < this.meassureData[key].length; i++) {
                    this.meassureData[key][i].forEach(item=>{
                        this.measures.forEach(j=>{
                            if(key==j.measureNo){
                                if(Number(parseInt(item[1]))>Number(JSON.parse(j.alarmDataJson).earlyWarningValue.split(',')[i])){
                                    if(Number(parseInt(item[1]))>Number(JSON.parse(j.alarmDataJson).alarmValue.split(',')[i])) {
                                        statusArr.push('red')
                                    }else{
                                        statusArr.push('yellow')
                                    }
                                }else{
                                    statusArr.push('green')
                                }
                            }
                        })
                    })
                }
                this.drawStatusC(key,statusArr)
            },
            /*绘制测点圆点颜色*/
            drawStatusC(number,statusArr){
                this.measures.forEach(i => {
                    if (number === i.measureNo) {
                        if(statusArr.indexOf('red')!==-1){
                            $('#statusC' + i.measureNo).css("background", "red")
                        }else if(statusArr.indexOf('yellow')!==-1){
                            $('#statusC' + i.measureNo).css("background", "#DDAA00")
                        } else{
                            $('#statusC' + i.measureNo).css("background", "green")
                        }
                    }
                })
            },
            //画预览图表
            drawChart(key) {
                let myChart;
                if (this.charts[key] == null) {
                    myChart = echarts.init(document.getElementById('data' + key));
                    this.charts[key] = myChart;
                } else {
                    myChart = this.charts[key];
                }
                let option = this.miniOption();
                if (this.meassureData[key] == null) {
                    return;
                }
                for (let i = 0; i < this.meassureData[key].length; i++) {
                    option.series.push(
                        {
                            type: 'line',
                            showSymbol: false,
                            data: this.meassureData[key][i],
                            smooth: true
                        }
                    );
                }
                myChart.setOption(option);
            },
            miniOption() {
                let option = {
                    grid: {
                        top: '5%',
                        left: '8%',
                        right: '8%',
                        bottom: '10%'
                    },
                    color: ['#409EFF', '#FB4D4B'],
                    xAxis: {
                        type: 'category',
                        show: false,
                    },
                    yAxis: {
                        type: 'value',
                        show: false,
                        boundaryGap: [0, '100%'],
                    },
                    series: []
                };
                return option;
            },
            formatDate(date) {
                let y = date.getFullYear();
                let m = date.getMonth() + 1;
                m = m < 10 ? '0' + m : m;
                let d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
                let h = date.getHours();
                h = h < 10 ? '0' + h : h;
                let mintues = date.getMinutes();
                mintues = mintues < 10 ? '0' + mintues : mintues;
                let seconds = date.getSeconds();
                seconds = seconds < 10 ? '0' + seconds : seconds;

                return y + '-' + m + '-' + d + "  " + h + ":" + mintues + ":" + seconds;
            },
            initMeasure() {
                this.measureNos = [];
                this.infoPics = [];
                this.popoverStatus = [];
                this.meassureData = {};
                for (let key in this.charts) {
                    this.charts[key].dispose();
                }
                this.charts = {};
            },
            getChart(measureNo,lable,norValue) {
                this.chartDialogVisible = true;
                this.mainMeasureNo = measureNo;
                this.lableName =lable+'——'+measureNo;
                this.norValue = JSON.parse(norValue).normalValue
            },
            loadChartData() {
                if (this.mainMeasureNo == null) {
                    return;
                }
                let myChart = echarts.init(document.getElementById("mainChart"));
                let option = {
                    title: {
                        text: '正常值范围:'+ this.norValue ,
                        left: 'center',
                        textStyle:{
                            color:'#E48F16'
                        }
                    },
                    grid: {
                        top: '10%',
                        left: '5%',
                        right: '5%',
                        bottom: '15%'
                    },
                    tooltip: {
                        // trigger: 'item',
                        trigger: 'axis',
                        axisPointer: { // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                        },
                        // formatter: '{c}',
                        // backgroundColor: "#FB4D4B", //设置边框颜色
                        borderRadius: 4,
                        textStyle: {
                            color: "#ffffff" //设置文字颜色
                        },
                    },
                    // 自定义线条颜色，所描绘的线条会在这里选颜色渲染
                    color: ['#409EFF', '#FB4D4B'],
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        // data: date,
                        axisLine:{
                            lineStyle:{
                                color:'#fff'
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ['rgba(245,250,255,0.5)']
                            }
                        },
                    },
                    yAxis: {
                        axisLine:{
                            lineStyle:{
                                color:'#fff'
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ['rgba(245,250,255,0.5)']
                            }
                        },
                    },
                    series: [],
                    dataZoom: [
                        {
                            type: "slider",
                            backgroundColor: "#ffffff",
                            fillerColor: "#E48F16",
                            showDataShadow: false,
                            height: 10,
                            left:'5%',
                            bottom: 15,
                            handleSize: "120%", // 手柄大小
                            borderColor: "none",
                            handleIcon: // 用于画手柄
                                "path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5M36.9,35.8h-1.3z M27.8,35.8 h-1.3H27L27.8,35.8L27.8,35.8z",// 画一个圆形
                            handleStyle: {
                                color: '#E48F16',
                                global: true  ,
                                shadowBlur: 6,
                                shadowColor: 'rgba(123, 154, 204, 0.5)',
                            }
                        },
                    ],
                };
                this.markLineData=[]
                this.getAlertData()
                for (let i = 0; i < this.meassureData[this.mainMeasureNo].length; i++) {
                    option.series.push(
                        {
                            itemStyle: {
                                normal: {
                                    lineStyle:{
                                        width:4//设置线条粗细
                                    }
                                }
                            },
                            symbolSize: 10,   //设定实心点的大小
                            type: 'line',
                            smooth: true,
                            data: this.meassureData[this.mainMeasureNo][i],
                            markLine: {
                                symbol: ['none'], // none为标线两端的样式为无，可更改
                                data:this.markLineData
                            },
                        }
                    );
                }
                myChart.setOption(option,true);
                window.onresize = myChart.resize;
            },
            /*绘制Echart的markLine*/
            getAlertData(){
                this.measures.forEach(i => {
                    if (this.mainMeasureNo === i.measureNo) {
                        JSON.parse(i.alarmDataJson).earlyWarningValue.split(',').forEach((item,index)=>{
                            let earlyWarning = {
                                yAxis:item,
                                label: {
                                    position: 'end', // 表现内容展示的位置
                                    formatter: '预警值'+[index+1],  // 标线展示的内容
                                    color: '#ffd337'  // 展示内容颜色
                                },
                                lineStyle: { type: 'solid', color: '#ffd337', width: 2 }
                            }
                            this.markLineData.push(earlyWarning)
                        })
                        JSON.parse(i.alarmDataJson).alarmValue.split(',').forEach((item,index)=>{
                            let alarmValue = {
                                yAxis:item,
                                label: {
                                    position: 'end', // 表现内容展示的位置
                                    formatter: '报警值'+[index+1],  // 标线展示的内容
                                    color: '#ff425d'  // 展示内容颜色
                                },
                                lineStyle: { type: 'solid', color: '#ff425d', width: 2 }
                            }
                            this.markLineData.push(alarmValue)
                        })
                    }
                })
            },
        },
        destroyed() {
            // 销毁监听
            if(this.socket) {
                this.socket.close()
                this.socket = null
                // console.log(22522)
            }
        },

    }
</script>

<style>
  .popoverDiv{
    margin: 0;
    padding: 0;
  }
  #realTimeData .el-menu {
    background-color: unset;
  }

  #realTimeData .el-submenu__title i {
    color: #e68f02;
  }

  #realTimeData .el-submenu__title{
    border-bottom: 1px solid rgba(255,255,255,0.52);
  }

  #realTimeData .el-menu-item{
    border-bottom: 1px solid rgba(255,255,255,0.52)!important;
  }

  #realTimeData .el-submenu__title:hover{
    background-color: #335abb!important;
    color:#000!important;
  }

  #realTimeData .el-menu-item:hover{
    background-color: #335abb!important;
    color:#000!important;
    border-bottom: none;
  }

  #realTimeData .el-menu-item.is-active{
    background-color: #335abb!important;
  }

  #realTimeData .el-submenu .el-menu {
    margin-left: 0;
    margin-right: 0;
  }

  #realTimeData .el-menu-item-group__title{
    padding: 0 0 0 20px;
  }

  /* 框架中.el-submenu .el-menu-item宽度min-width: 200px,最小宽度设置为150px,防止超出长度 */
  #realTimeData .el-submenu .el-menu-item{
    min-width: 150px;
  }

  .leadTips {
    display: flex;
    justify-content: start;
    width: 180px;
    transform: translateY(-40px)
  }

  .leadTips img {
    display: inline-block;
    width: 49px;
    height: 49px
  }

  .leadText {
    display: block;
    background: green;
    color: #fff;
    padding: 10px 5px;
    font-size: 12px;
    cursor: pointer;
  }
  .lableState{
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #00ff80;
  }

</style>


<style scoped>
  @import "../../assets/css/style.css";

  .scroll_panel {
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 1000;
  }

  .scroll_panel button {
    width: 30px;
    text-align: center;
    padding: 5px
  }
  * {
    margin: 0;
    padding: 0
  }

  html, body {
    height: 100%
  }


  li {
    list-style: none;
  }

  .model_panel {
    width: 100%;
    height: 300px;
    flex: 1;
    position: relative;
  }
  /*新增样式 下箭头*/
  .downArrow{
    text-align: center;
    line-height: 30px;
    font-size: 28px;
    font-weight: bold;
    color: #FFFFFF;
  }
  .miniContent{
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .miniCar{
    width: 92%;
  }
  .mini_chart_panel {
    width:18%;
    float: left;
    margin-left:1%;
    margin-right:1%;
    display: flex;
    flex-direction: column;
    position: relative;
    margin-bottom: 10px;
  }

  .mini_chart_panel > img {
    width: 100%;
  }

  .mini_chart_panel > .chart_content {
    position: absolute;
    width: 100%;
    color: #FFFFFF;
  }

  .mini_chart {
    height: 60px;
  }

  .nav_menu{
    height: 100%;
    border: 2px solid #345fc7;
    margin-left: 30px;
    margin-right: 30px;
  }
  /deep/ .el-dialog {
    background: linear-gradient(
      -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%);
    border-radius: 2.5px 2.5px 0px 0px;
    transition: unset;
  }
  /deep/  .el-dialog__body{
    padding: 4px 0;
  }
  /deep/  .el-dialog__title{
    text-align: center;
    font-size: 28px;
    color: rgb(218, 217, 254);
    font-weight: bold;
    white-space: normal;
    word-break: normal;
  }
  /deep/ .el-dialog__headerbtn{
    background-color: #001334;
    padding: 5px 5px;
  }
  /*/deep/ .el-dialog__footer{*/
  /*  background-color: #001334;*/
  /*  width: 99%;*/
  /*  text-align: inherit;*/
  /*  z-index: 2;*/
  /*  margin: 0 auto 4px auto;*/
  /*  padding: 0 0 4px 0;*/
  /*}*/
  #mainChart{
    margin: auto auto 0 auto;
    padding: 20px 0;
    background-color: #001334;
  }
  #changeLine{
    margin: auto auto auto auto;
    background-color: #001334;
    width: 99%;
    text-align: center;
  }
  .circularStatus{
    background: green;
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }






</style>



// WEBPACK FOOTER //
// src/components/monitor/real-time-data-2d.vue